import styled from "styled-components";
import { Colors } from "../../globalStyles";

export const CustomEditText = styled.input<any>`  
  background-color:  lightgrey;  
  outline-color: ${({ error }) => (error ? Colors.error : "")};
  border-color : ${({ error }) => (error ? Colors.error : "")};
  padding:0.8rem ;
  

  &:focus{
    border-color : ${({ error }) => (error ? Colors.error : "")};
  }
`;
